import classNames from 'classnames';
import { bool, func, object } from 'prop-types';

import ImageTranslator from '~/components/Image/ImageTranslator';

import style from './PaymentMethodButton.module.scss';

const PaymentMethodButton = ({ data, selected, onClick }) => {
  const imageProps = {
    alt: data.name || data.type,
    className: 'button',
    src: data.icon,
  };
  return (
    <div
      className={classNames(style.method, { selected })}
      onClick={() => onClick(data)}
    >
      {typeof data.icon === 'object' ? (
        <ImageTranslator {...imageProps} />
      ) : (
        <img
          {...imageProps}
          alt={imageProps.alt}
        />
      )}
      {!!data.img && (
        <img
          alt={data.name}
          className="button-img"
          src={data.img}
        />
      )}
    </div>
  );
};
PaymentMethodButton.propTypes = {
  data: object,
  selected: bool,
  onClick: func,
};

export default PaymentMethodButton;
